import {StatusIcons} from "assets/icons/status/status.index";
import theme from "theme/theme";
import { en } from "language/en";
import {StatusItem} from "assets/arrayList/ProjectStatus";
const enTask = en.screen.Task.status;

const pending  : StatusItem = {
  title: enTask.pending,
  icon: StatusIcons.Pending,
  color: theme.palette.secondary.main,
  checked: false,
}

export default pending